/**
 * resolveText / resolveTextOptional / resolveTextArray
 *
 * The template engine allows TextInput values to be either a plain string
 * or an animated text object: { text: string, animation?, zIndex? }.
 * These utilities normalise both forms to a plain string for rendering.
 */

/** @param {string | { text: string }} value */
export function resolveText(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && typeof value.text === "string") return value.text;
  return String(value);
}

/** @param {string | { text: string } | undefined} value */
export function resolveTextOptional(value) {
  if (value === undefined || value === null) return null;
  return resolveText(value);
}

/** @param {Array<string | { text: string }>} values */
export function resolveTextArray(values) {
  if (!Array.isArray(values)) return [];
  return values.map(resolveText);
}
